import {Fragment, h, Component} from 'preact';
import {formatPrice, formatPriceWithSymbol} from "../../tools";

export default class AmountBlock extends Component {

	/**
	 * @param {{amount: number, paymentUrl}} props
	 */
	constructor(props){
		super(props);
	}

	render({amount, paymentUrl}, {}, context){
		if(!amount) return <Fragment/>;
		return (
			<Fragment>
				<div className="main__section total-block-wrapper">
					<div className="form-block debt-total-section main__item">
						<div className="block-with-label__title block-with-label__title_fz_lg">Оплата</div>
						<div className="form-block__description">
							Оплатите электроэнергию и другие услуги онлайн с помощью банковской карты.
						</div>
						<div className="form-block__item">
							<div className="form-block__line">
								<div className="form-field">
									<div className="form-field__inner">
										<div className="debt-total-section__amount row row_jc_sb">
											<div className="col col-12 col-lg-5 col_p-0 debt-total-section__amount-title">К оплате</div>
											<div className="col col-12 col-lg-7 col_p-0 text-lg text-right  debt-total-section__amount-value">{formatPrice(amount)} ₽</div>
										</div>
									</div>
								</div>
							</div>
							<a className="button-primary form-block__footer-item" href={paymentUrl}>
								<span className="button-primary__icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.333 2.66667H2.66634C1.92634 2.66667 1.33967 3.26 1.33967 4L1.33301 12C1.33301 12.74 1.92634 13.3333 2.66634 13.3333H13.333C14.073 13.3333 14.6663 12.74 14.6663 12V4C14.6663 3.26 14.073 2.66667 13.333 2.66667ZM13.333 12H2.66634V8H13.333V12ZM13.333 5.33334H2.66634V4H13.333V5.33334Z" fill="#1A47A9"/></svg></span><span className="button-primary__text">Оплатить {formatPriceWithSymbol(amount)}</span>
							</a>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}
